import React, { useEffect } from 'react';

const Sponsors = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className="page-hero">
        <div className="container page-hero__content">
          <h1 className="page-hero__title">Partner With Us</h1>
          <div className="breadcrumb">
            <a href="/">Home</a> <span>/</span> Sponsors
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="text-center mb-12">
            <div className="eyebrow" style={{justifyContent: 'center'}}>Why Partner with LLC 2026</div>
            <h2 className="section-title">Amplify Your Brand Impact</h2>
            <p className="section-body" style={{maxWidth: 700, margin: '0 auto'}}>
              Sponsoring LinkedIn Local Cameroon 2026 positions your brand directly in front of over 2,000 active professionals, young leaders, and decision-makers in the region.
            </p>
          </div>

          <div className="welcome-grid" style={{marginBottom: 80}}>
            <div style={{background: '#fff', padding: 24, borderRadius: 12, boxShadow: 'var(--shadow)', borderLeft: '4px solid var(--blue)'}}>
              <h3 style={{fontFamily: 'Montserrat', fontSize: 18, color: 'var(--blue)', marginBottom: 8}}>Digital Access to our core market</h3>
              <p style={{fontSize: 14, color: 'var(--text-body)'}}>2,000 of Cameroon's most commercially active professionals, all in one room, for one full day. No advertising medium delivers this concentration of qualified audience.</p>
            </div>
            <div style={{background: '#fff', padding: 24, borderRadius: 12, boxShadow: 'var(--shadow)', borderLeft: '4px solid var(--red)'}}>
              <h3 style={{fontFamily: 'Montserrat', fontSize: 18, color: 'var(--red)', marginBottom: 8}}>National + Digital Reach</h3>
              <p style={{fontSize: 14, color: 'var(--text-body)'}}>Your brand goes beyond the 2,000 in the room. The LLC 2026 livestream and social media campaign will reach 10,000+ additional viewers across Cameroon and diaspora.</p>
            </div>
            <div style={{background: '#fff', padding: 24, borderRadius: 12, boxShadow: 'var(--shadow)', borderLeft: '4px solid var(--yellow)'}}>
              <h3 style={{fontFamily: 'Montserrat', fontSize: 18, color: 'var(--yellow)', marginBottom: 8}}>Measurable, Documented Impact</h3>
              <p style={{fontSize: 14, color: 'var(--text-body)'}}>Every Gold and Platinum partner receives a post-event impact report within 20 days with certificated attendance, media impressions, social analytics and reach data.</p>
            </div>
            <div style={{background: '#fff', padding: 24, borderRadius: 12, boxShadow: 'var(--shadow)', borderLeft: '4px solid var(--blue)'}}>
              <h3 style={{fontFamily: 'Montserrat', fontSize: 18, color: 'var(--blue)', marginBottom: 8}}>Brand Association with Excellence</h3>
              <p style={{fontSize: 14, color: 'var(--text-body)'}}>LLC 2026 is Cameroon's most ambitious professional event. The brands that appear alongside it inherit that association - with ambition, leadership and the country's future.</p>
            </div>
            <div style={{background: '#fff', padding: 24, borderRadius: 12, boxShadow: 'var(--shadow)', borderLeft: '4px solid var(--red)'}}>
              <h3 style={{fontFamily: 'Montserrat', fontSize: 18, color: 'var(--red)', marginBottom: 8}}>CSR that Creates Real Value</h3>
              <p style={{fontSize: 14, color: 'var(--text-body)'}}>Your investment directly funds the professional development of 2,000 young Cameroonians. This is CSR with documented human impact - ideal for annual reports.</p>
            </div>
            <div style={{background: '#fff', padding: 24, borderRadius: 12, boxShadow: 'var(--shadow)', borderLeft: '4px solid var(--yellow)'}}>
              <h3 style={{fontFamily: 'Montserrat', fontSize: 18, color: 'var(--yellow)', marginBottom: 8}}>First-Mover Advantage</h3>
              <p style={{fontSize: 14, color: 'var(--text-body)'}}>LLC 2026 is a growing institution. The partners who invest now establish relationships and naming rights in a community that will grow larger every year.</p>
            </div>
          </div>

          <div className="text-center mt-12" style={{marginTop: 80}}>
            <h2 className="section-title">Official Partnership Tiers</h2>
          </div>

          <div className="sponsor-tiers" style={{gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))'}}>
            {/* Bronze */}
            <div className="sponsor-tier">
              <div className="sponsor-tier__badge badge-bronze" style={{background: '#cd7f32', color: '#fff', display: 'inline-block', padding: '4px 12px', borderRadius: 4, fontWeight: 700, fontSize: 12, textTransform: 'uppercase', marginBottom: 16}}>Bronze</div>
              <h3 className="sponsor-tier__title" style={{fontSize: 24}}>50,000</h3>
              <div className="sponsor-tier__price" style={{fontSize: 14, color: 'var(--text-muted)'}}>FCFA</div>
              <div className="sponsor-benefit">Logo on all materials</div>
              <div className="sponsor-benefit">2 delegates passes</div>
              <div className="sponsor-benefit">2 social media posts</div>
              <div className="sponsor-benefit">Partnership certificate</div>
            </div>

            {/* Silver */}
            <div className="sponsor-tier">
              <div className="sponsor-tier__badge badge-silver" style={{background: '#c0c0c0', color: '#000', display: 'inline-block', padding: '4px 12px', borderRadius: 4, fontWeight: 700, fontSize: 12, textTransform: 'uppercase', marginBottom: 16}}>Silver</div>
              <h3 className="sponsor-tier__title" style={{fontSize: 24}}>150,000</h3>
              <div className="sponsor-tier__price" style={{fontSize: 14, color: 'var(--text-muted)'}}>FCFA</div>
              <div className="sponsor-benefit">Prominent logo placement</div>
              <div className="sponsor-benefit">5 delegates passes</div>
              <div className="sponsor-benefit">Exhibition booth</div>
              <div className="sponsor-benefit">5 social media posts</div>
              <div className="sponsor-benefit">Press mention</div>
            </div>

            {/* Gold */}
            <div className="sponsor-tier sponsor-tier--gold" style={{transform: 'scale(1.05)', borderColor: 'var(--yellow)'}}>
              <div className="sponsor-tier__badge badge-gold" style={{background: 'var(--yellow)', color: '#000', display: 'inline-block', padding: '4px 12px', borderRadius: 4, fontWeight: 700, fontSize: 12, textTransform: 'uppercase', marginBottom: 16}}>Gold</div>
              <h3 className="sponsor-tier__title" style={{fontSize: 24}}>500,000</h3>
              <div className="sponsor-tier__price" style={{fontSize: 14, color: 'var(--text-muted)'}}>FCFA</div>
              <div className="sponsor-benefit">Premium logo - stage & screens</div>
              <div className="sponsor-benefit">10 delegates passes</div>
              <div className="sponsor-benefit">Exhibition booth</div>
              <div className="sponsor-benefit">5 min speaking slot</div>
              <div className="sponsor-benefit">10 social media posts</div>
              <div className="sponsor-benefit">Post event impact report</div>
              <div style={{marginTop: 16, fontSize: 11, fontWeight: 700, color: 'var(--yellow)', textTransform: 'uppercase'}}>★ Recommended</div>
            </div>

            {/* Platinum */}
            <div className="sponsor-tier">
              <div className="sponsor-tier__badge badge-platinum" style={{background: '#e5e4e2', color: '#000', display: 'inline-block', padding: '4px 12px', borderRadius: 4, fontWeight: 700, fontSize: 12, textTransform: 'uppercase', marginBottom: 16}}>Platinum</div>
              <h3 className="sponsor-tier__title" style={{fontSize: 24}}>50,000</h3>
              <div className="sponsor-tier__price" style={{fontSize: 14, color: 'var(--text-muted)'}}>FCFA</div>
              <div className="sponsor-benefit">Premium logo - all materials</div>
              <div className="sponsor-benefit">20 VIP passes + gala access</div>
              <div className="sponsor-benefit">10 min keynote slot</div>
              <div className="sponsor-benefit">Exhibition booth</div>
              <div className="sponsor-benefit">20+ social media posts</div>
              <div className="sponsor-benefit">Full impact report</div>
            </div>
          </div>
          
          <div className="text-center mt-12">
            <p style={{fontStyle: 'italic', color: 'var(--text-muted)', marginBottom: 24}}>Custom Title sponsorship packages available - contact us for tailored structure.</p>
            <a href="mailto:info@linkedinlocalcameroon.com" className="btn btn-red btn-lg">Request Sponsorship Deck</a>
          </div>
        </div>
      </section>
    </>
  );
};

export default Sponsors;
